function buocChonChuVuon() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Chọn chủ vườn",
      content:
        "Đây là bước đầu của luồng thu mua. Cần xác định đúng chủ vườn trước khi chọn vườn và cân bơ.",
    },
    {
      target: "#tour-thu-mua-che-do-quet",
      title: "Bước 2 · Quét QR hoặc nhập tay",
      content:
        'Ưu tiên quét mã QR dán tại vườn (nhanh, ít sai). Nếu không có QR, chuyển sang "Nhập tay" rồi tìm theo CCCD / SĐT / mã chủ vườn.',
      placement: "bottom",
    },
    {
      target: "#tour-thu-mua-them-moi",
      title: "Bước 3 · Chủ vườn mới",
      content:
        "Không tìm thấy trong hệ thống? Bấm thêm chủ vườn mới ngay tại đây, điền hồ sơ tối thiểu rồi tiếp tục thu mua.",
      placement: "top",
    },
  ];
}

export default buocChonChuVuon;
